import { render, staticRenderFns } from "./ConferencesNavItem.vue?vue&type=template&id=858ef42c&"
import script from "./ConferencesNavItem.vue?vue&type=script&lang=js&"
export * from "./ConferencesNavItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports